import React, { useContext, useMemo } from "react";
import { Box, Stack } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { useHistory, useLocation } from "react-router-dom";

import AiContractorSearch from "../../../../components/Dashboard/AiContractorSearch";
import DashboardShell from "../../../../components/DashboardShell";
import { AuthContext } from "../../../../components/FirebaseAuth";
import adminDashboardNav from "../../admin/Dashboard/dashboardNav";
import clientDashboardNav from "../../client/Dashboard/dashboardNav";

const searchNavItem = {
  key: "search",
  label: "Search",
  description: "Find contractors",
  icon: <SearchOutlinedIcon fontSize="small" />,
};

const DashboardSearch = () => {
  const history = useHistory();
  const location = useLocation();
  const { authUser } = useContext(AuthContext);
  const role = String(authUser?.role || "").toLowerCase();
  const query = new URLSearchParams(location.search).get("q") || "";

  const navItems = useMemo(() => {
    const baseItems = role === "admin" ? adminDashboardNav : clientDashboardNav;
    return [...baseItems, searchNavItem];
  }, [role]);

  const handleSelect = (key) => {
    if (key === "search") return;
    history.push(role === "admin" ? "/admin/dashboard" : "/client/dashboard");
  };

  return (
    <Box sx={{ width: "100%", textAlign: "left" }}>
      <DashboardShell
        title="Search"
        items={navItems}
        activeKey="search"
        onSelect={handleSelect}
        headerless
      >
        <Stack spacing={2}>

          <AiContractorSearch
            key={query || "empty-search"}
            title="Contractor search"
            description="Search by skill, tool, role, level, location, or budget."
            initialQuery={query}
            autoSearch={query.trim().length >= 3}
            showExamples={!query.trim()}
          />
        </Stack>
      </DashboardShell>
    </Box>
  );
};

export default DashboardSearch;
